// src/api/inventory.js
import axios from 'axios'

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '/neue/admin',
  headers: { 'Content-Type': 'application/json' },
})

apiClient.interceptors.request.use(cfg => {
  const token = localStorage.getItem('auth_token')
  if (token) cfg.headers.Authorization = `Bearer ${token}`
  return cfg
}, err => Promise.reject(err))

apiClient.interceptors.response.use(r => r, err => {
  if (err.response?.status === 401) {
    localStorage.removeItem('auth_token')
    window.location.href = '/login'
  }
  return Promise.reject(err)
})

// summary cards
export async function fetchSummary() {
  const { data } = await apiClient.get('/neue/admin/inventory/summary')
  return data?.data ?? data
}

// paged ledger with sorting
export async function fetchLedger(params) {
  const { page, pageSize, search, reason, sortKey, sortOrder } = params || {}
  const { data } = await apiClient.get('/neue/admin/inventory/ledger', {
    params: {
      page,
      pageSize,
      search,
      reason,
      sortKey,
      sortOrder
    }
  })
  // expect { items: [...], total: N }
  return data
}

// create entry
export async function createEntry(payload) {
  const { data } = await apiClient.post('/neue/admin/inventory/entry', payload)
  return data
}

// per SKU history
export async function fetchHistory(sku) {
  const { data } = await apiClient.get(`/neue/admin/inventory/history/${encodeURIComponent(sku)}`)
  return data?.items ?? data
}

export async function deleteByReference(referenceId) {
  const { data } = await apiClient.delete(
    `/neue/admin/inventory/by-reference/${encodeURIComponent(referenceId)}`
  )
  return data
}
